export const getIconSize = size => {
  let width = ''
  let height = ''
  switch (size) {
    case 'xs':
      width = '12'
      height = '12'
      break
    case 'md':
      width = '16'
      height = '16'
      break
    case 'lg':
      width = '20'
      height = '20'
      break
    case 'xl':
      width = '24'
      height = '24'
      break
    default:
      width = ''
      height = ''
  }
  return { width, height }
}
